import * as Yup from "yup";
import SubGroupModel from "../../models/products/subgroup-model";
import { API_END_POINT } from "../../constants";
import { InputField } from "../../components/form/input.field.component";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import { CheckboxField, CheckBoxStyle } from "../../core/checkbox-field.component";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import UOMModel from "../../models/products/uom-model";
import { useEffect, useState } from "react";
import { useGetUoms } from "../../apiclient/product/useGetUOMApi";

interface UOMEditProps {
    data: UOMModel;
    isViewMode?: boolean;
    onClose?: (status: SubmitStatus, data: any) => any;
}

const UOMEntry: React.FC<UOMEditProps> = ({ ...props }) => {
    let { data, onClose,isViewMode} = props;
    const title = data?.uomId > 0 ? "Edit UOM" : "Add UOM";

    let initialValue: UOMModel = {
        uomId: data?.uomId || 0,
        name: data?.name,
        shortName:data?.shortName,
    };
    const validationSchema = Yup.object().shape({
        name: Yup.string()
    .required("Required")
    .test("check-duplicate-name", "UOM  already exists", (value) => {
      // Ensure the value is compared in a case-insensitive manner
      return (
        value &&
        !existingName.some(existing => existing.toLowerCase() === value.toLowerCase()) ||
        (data?.name && value === data.name) // Allow current name during update
      );
    }), 
        });

        const [existingName, setExistingName] = useState<string[]>([]);
  const { data: fetchedUOM } = useGetUoms();


  useEffect(() => {

        
    if (fetchedUOM) {
        setExistingName(fetchedUOM.map((cat: any) => cat.name));
    }
       
    }, [fetchedUOM]);
    return (
        <>
            <FormikModelDialog
                width="50%"
                title={title}
                initialData={initialValue}
                validationSchema={validationSchema}
                show={!!data}
                onClose={onClose}
                endpoint={API_END_POINT.PRODUCT}
                postRoute="UOM/SaveUOM"
                showAddAnother={true}
                isViewOnly ={isViewMode}

                isUpDateEntityDetails={data?.uomId > 0 ? true : false}

            >
                <div>
                    <div className="row">
                        <div className="col-6">
                            <InputField maxLength={150} label="Name *" name="name" />
                        </div>
                        <div className="col-6">
                            <InputField maxLength={150} label="Short Name" name="shortName" />
                        </div>
                    </div>
                </div>
            </FormikModelDialog>
        </>
    );
};

export default UOMEntry;
